// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { rem } from "polished";
import styled from "styled-components";

import { IllustratedCard } from "~@jii/common-ui";
import { palette, spacing, typography } from "~design-system";

const DISMISS_BUTTON_SIZE = 32;

export const Banner = styled(IllustratedCard)`
  margin: 0;
`;

export const Title = styled.h2`
  ${typography.Serif24}

  color: ${palette.pine1};
  margin: 0 0 ${rem(spacing.sm + spacing.xs)};
  padding-right: ${rem(DISMISS_BUTTON_SIZE)};
`;

export const Description = styled.p`
  ${typography.Sans16}

  color: ${palette.slate85};
  margin: 0;
`;

export const DismissButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: ${rem(DISMISS_BUTTON_SIZE)};
  justify-content: center;
  position: absolute;
  right: ${rem(spacing.sm)};
  top: ${rem(spacing.sm)};
  width: ${rem(DISMISS_BUTTON_SIZE)};
`;
